<template>
  <div class="mt-4">
    <fragment>
      <page-head
        small
        :back-route-path="'/bankruptcy'"
        show-back
      >
        <div class="head-wings">
          <div
            v-show="$vuetify.breakpoint.lgAndUp"
            class="wing"
          >
            <request-stepper
              :current-step="currentStep"
              :steps="steps"
              @onUpdateCurrentStep="onUpdateCurrentStep"
            ></request-stepper>
          </div>
          <div :class="['wing r-info', {'not-new-mode': !isNewMode}]">
            <request-info v-if="!isNewMode"></request-info>
          </div>
        </div>
      </page-head>

      <page-content small>
        <basic-data
          v-if="currentStep === stepsEnum.basicData"
          @onUpdateCurrentStep="onUpdateCurrentStep"
        ></basic-data>
        <request-applicant-data
          v-if="currentStep === stepsEnum.requestApplicantData"
          @onUpdateCurrentStep="onUpdateCurrentStep"
        ></request-applicant-data>
        <request-details
          v-if="currentStep === stepsEnum.requestDetails"
          @onUpdateCurrentStep="onUpdateCurrentStep"
        ></request-details>
        <request-attachments
          v-if="currentStep === stepsEnum.requestAttachments"
          @onUpdateCurrentStep="onUpdateCurrentStep"
        ></request-attachments>
      </page-content>

      <request-incomplete-reasons
        v-if="isNotCompleted && requestObjectKey"
        :request-object-key="requestObjectKey"
      ></request-incomplete-reasons>
    </fragment>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapActions, mapState: mapState, mapGetters } = createNamespacedHelpers('BankruptcyModule');
import BasicData from './steps/basic-data';
import RequestStepper from './request-stepper/index.vue';
import RequestInfo from './request-info/index.vue';
import RequestDetails from './steps/request-details';
import RequestApplicantData from './steps/request-applicant-data';
import RequestAttachments from './steps/request-attachments';
import { stepsEnum, requestOwnerTypeEnum } from '@/modules/bankruptcy/helpers/enum';
import RequestIncompleteReasons from '@/modules/bankruptcy/components/request/request-incomplete-reasons/index';

export default {
  name: 'Bankruptcy',
  components: {
    RequestStepper,
    RequestInfo,
    RequestAttachments,
    BasicData,
    RequestDetails,
    RequestApplicantData,
    RequestIncompleteReasons,
  },
  data() {
    return {
      stepsEnum,
      requestOwnerTypeEnum,
    };
  },
  computed: {
    ...mapState({ mainRequest: state => state.mainRequest }),
    ...mapGetters([
      'isNewMode',
      'isNotCompleted',
    ]),
    steps() {
      return [
        {
          id: stepsEnum.basicData,
          title: this.local.bankruptcy.request.tabs.basicData,
          enabled: true,
        },
        {
          id: stepsEnum.requestApplicantData,
          title: this.local.bankruptcy.request.tabs.requestApplicantData,
          enabled: true,
        },
        {
          id: stepsEnum.requestDetails,
          title: this.local.bankruptcy.request.tabs.requestDetails,
          enabled: this.showRequestDetailsTab,
        },
        {
          id: stepsEnum.requestAttachments,
          title: this.local.bankruptcy.request.tabs.requestAttachments,
          enabled: true,
        },
      ].filter(t => t.enabled).map((item, index) => {
        return {
          ...item,
          order: index + 1,
        };
      });
    },
    showRequestDetailsTab() {
      return !this.mainRequest.requestOwnerTypeId || this.mainRequest.requestOwnerTypeId == requestOwnerTypeEnum.debtor;
    },
    currentStep() {
      return (this.stepParam || 1) * 1;
    },
    stepParam() {
      return this.$route.params.step;
    },
    requestObjectKey() {
      return this.$route.params.objectKey;
    },
  },
  watch: {
    requestObjectKey: function (objectKey) {
      this.openRequest({
        currentStep: this.stepParam || 1,
        objectKey,
      });
    },
  },
  created() {
    this.openRequest({
      currentStep: this.stepParam || 1,
      objectKey: this.requestObjectKey,
    });
  },
  methods: {
    ...mapActions(['openRequest']),
    onUpdateCurrentStep(stepId) {
      if (this.currentStep === stepId) return;
      this.setStepIndex(stepId);
    },
    setStepIndex(stepId) {
      let url = `/bankruptcy/request/${stepId}`;
      if (this.requestObjectKey) {
        url += `/${this.requestObjectKey}`;
      }
      this.$router.push({ path: url });
    },
  },
};
</script>

<style lang="scss" scoped>
    .head-wings {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .r-info {
            margin-left: 40px;
        }

        .not-new-mode {
            margin-left: 10px;
            margin-top: -22px;

            &::v-deep {
                .request-info-root {
                    background-color: var(--app-light-secondary-color);
                    padding: 10px 20px;
                    border-radius: 5px;
                    border: 1px solid var(--app-primary-color);

                    > div {
                        min-width: 170px;

                        > b {
                            display: flex;
                            width: 100%;
                            justify-content: space-between;
                            font-weight: 700;
                            margin-bottom: 5px;

                            > span {
                                margin-right: 0;
                                margin-left: 5px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
